import React from 'react'
import { AimOutlined, CompassOutlined } from '@ant-design/icons'
import DiamondIcon from 'features/chats/components/DiamondIcon'
import { getStarterFallbackColor } from 'utils/get-starter-fallback-color'

interface StarterFallbackIconProps {
  /** Position of the starter in its list, used to pick a deterministic palette color. */
  index: number
  flowId?: number
  flow?: { isDefault?: boolean }
  /** Visual size (px) of the icon. The diamond and flow icons render at the same size. */
  size?: number
}

/**
 * Fallback icon for a starter that has no image. Mirrors the chat behavior:
 * flow starters get the Compass/Aim icon, everything else gets a colored diamond.
 *
 * Both icon kinds are rendered inside a fixed `size x size` box so a given `size`
 * produces the same visual footprint regardless of which icon is shown.
 */
const StarterFallbackIcon: React.FC<StarterFallbackIconProps> = ({ index, flowId, flow, size = 20 }) => {
  let icon: React.ReactNode
  if (flowId) {
    icon = flow?.isDefault ? <AimOutlined style={{ fontSize: size }} /> : <CompassOutlined style={{ fontSize: size }} />
  } else {
    icon = <DiamondIcon color={getStarterFallbackColor(index)} size={size} />
  }

  return (
    <span className="inline-flex items-center justify-center" style={{ width: size, height: size }}>
      {icon}
    </span>
  )
}

export default StarterFallbackIcon
